import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock, X } from 'lucide-react';

const DISMISS_KEY = 'compass_trial_ending_dismissed';

/**
 * Fixed gold banner shown when trial has 3 days or fewer remaining.
 * Dismissible per-session only (returns on next page load / login).
 */
const TrialEndingBanner = ({ user }) => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === 'true'
  );

  const inTrial = user?.in_trial;
  const days = user?.trial_days_remaining ?? 0;

  if (!inTrial || days > 3 || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div
      role="alert"
      aria-live="polite"
      className="fixed top-0 inset-x-0 z-[200] bg-amber-500 text-black flex items-center justify-between gap-3 px-4 py-2"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Clock className="w-4 h-4 shrink-0" aria-hidden />
        <p className="text-sm font-medium leading-tight">
          Plus que <strong>{days} jour{days !== 1 ? 's' : ''}</strong> d'essai Famille.
          {' '}Passe à Solo ou Famille pour garder tes données actives.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Link
          to="/pricing?source=trial_ending"
          className="text-xs font-bold bg-black/20 hover:bg-black/30 px-3 py-1 rounded-full transition-colors whitespace-nowrap"
        >
          Choisir mon plan
        </Link>
        <button
          onClick={handleDismiss}
          aria-label="Fermer"
          className="p-1 hover:bg-black/20 rounded-full transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default TrialEndingBanner;
